<template>
  <b-card no-body>
    <b-overlay :show="loading" rounded="sm" variant="light">
      <b-card-header>
        <div>
          <b-card-title class="mb-1">
            {{ $t("dashboard.responseTime") }}
          </b-card-title>
        </div>
      </b-card-header>

      <b-card-body>
        <chartjs-component-bar-chart
          :key="`responseTimeBarChart${key}`"
          :height="300"
          :data="chartjsData.responseTimeBarChart.data"
          :options="chartjsData.responseTimeBarChart.options"
        />
      </b-card-body>
    </b-overlay>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BCardSubTitle,
  BCardTitle,
  BButtonGroup,
  BButton,
  BOverlay,
} from "bootstrap-vue";
import ChartjsComponentLineChart from "@/components/charts-components/ChartjsComponentLineChart.vue";
import ChartjsComponentBarChart from "@/components/charts-components/ChartjsComponentBarChart.vue";
import chartjsData from "./chartjsData";
import Ripple from "vue-ripple-directive";
import useJwt from '@/auth/jwt/useJwt';

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BCardSubTitle,
    BCardTitle,
    BButtonGroup,
    BButton,
    BOverlay,
    ChartjsComponentLineChart,
    ChartjsComponentBarChart,
  },
  directives: {
    Ripple,
  },
  props: {
    chartData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },
    userData: function () {
      return this.$store.state.profile.email || this.$store.state.profile.phone  
        ? this.$store.state.profile
        : JSON.parse(localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName));
    },
  },
  watch: {
    currentLocale(value, oldValue) {
      if (oldValue && value && this.chartData?.data?.length) {
        this.mapChartData(this.chartData);
      }
    },
  },
  data() {
    return {
      chartjsData,
      key: 1,
    };
  },
  methods: {
    mapChartData(data) {
      let labels = data.labels.map((element) => {
        return element
          .replace("sec", this.$t("general.seconds"))
          .replace("min", this.$t("general.minutes"));
      });

      this.chartjsData.responseTimeBarChart.data.labels = [...labels];
      this.chartjsData.responseTimeBarChart.data.datasets[0].data = [
        ...data.data,
      ];
      this.chartjsData.responseTimeBarChart.data.datasets[0].label = this.$t(
        "dashboard.responseTime"
      );
      this.key++;
    },
  },
};
</script>
